import { render, staticRenderFns } from "./avatar.html?vue&type=template&id=7056810e&scoped=true&"
import script from "./avatar.js?vue&type=script&lang=js&"
export * from "./avatar.js?vue&type=script&lang=js&"
import style0 from "./avatar.scss?vue&type=style&index=0&id=7056810e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7056810e",
  null
  
)

export default component.exports